import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import Checkout from '@/components/checkout/Checkout.vue';
import { useGtm } from '@/composables';


const __default__ = {
  name: 'CheckoutPage',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { trackGtmEvent } = useGtm();

onMounted(() => {
  trackGtmEvent('Checkout page', 'Page', 'Loaded', 'Checkout page is loaded');
});

return { __sfc: true,trackGtmEvent, Checkout }
}

})